module.exports = __webpack_public_path__ + "static/media/C_Version_I-Won.4de4182a.gif";